export enum PortOvertimeLevel {
  REGULAR = 'regular',
  OT1 = 'ot1',
  OT2 = 'ot2',
}
